import DownloadIcon from '@mui/icons-material/Download';
import { Box, Card, CardContent, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { downloadFile, metricsToCSV } from '../../../utils/exportUtils';

interface SmsTeam {
  teamId: number;
  teamName: string;
  totalMessages: number;
  inboundMessages: number;
  outboundMessages: number;
}

interface SmsTeamsTabProps {
  teams: SmsTeam[];
  comparison?: SmsTeam[];
  renderMetricCard: (
    title: string,
    value: number | string,
    comparison?: number | string,
    rawValue?: number,
    invertColors?: boolean,
  ) => JSX.Element;
  currentStartDate?: string;
  currentEndDate?: string;
  previousStartDate?: string;
  previousEndDate?: string;
}

export const SmsTeamsTab = ({
  teams,
  comparison,
  renderMetricCard,
  currentStartDate,
  currentEndDate,
  previousStartDate,
  previousEndDate,
}: SmsTeamsTabProps) => {
  const handleExportTeam = (team: SmsTeam, comparisonTeam?: SmsTeam) => {
    if (!currentStartDate || !currentEndDate) return;

    const teamMetrics = [
      { label: 'Team Name', value: team.teamName, previousValue: comparisonTeam?.teamName },
      { label: 'Total Messages', value: team.totalMessages, previousValue: comparisonTeam?.totalMessages },
      { label: 'Inbound', value: team.inboundMessages, previousValue: comparisonTeam?.inboundMessages },
      { label: 'Outbound', value: team.outboundMessages, previousValue: comparisonTeam?.outboundMessages },
    ];

    const csv = metricsToCSV(teamMetrics, currentStartDate, currentEndDate, previousStartDate, previousEndDate);
    downloadFile(csv, `sms-team-${team.teamName.replace(/\s+/g, '-').toLowerCase()}-metrics.csv`);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant='h6' gutterBottom>
        Team Metrics
      </Typography>
      <Grid container spacing={3}>
        {teams.map((team) => {
          const comparisonTeam = comparison?.find((t) => t.teamId === team.teamId);
          return (
            <Grid item xs={12} key={team.teamId}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant='h6'>{team.teamName}</Typography>
                    <Tooltip title='Export team metrics'>
                      <IconButton size='small' onClick={() => handleExportTeam(team, comparisonTeam)} sx={{ color: '#1a667a' }}>
                        <DownloadIcon fontSize='small' />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      {renderMetricCard(
                        'Total Messages',
                        team.totalMessages,
                        comparisonTeam?.totalMessages,
                        undefined,
                        false,
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      {renderMetricCard(
                        'Inbound',
                        team.inboundMessages,
                        comparisonTeam?.inboundMessages,
                        undefined,
                        false,
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      {renderMetricCard(
                        'Outbound',
                        team.outboundMessages,
                        comparisonTeam?.outboundMessages,
                        undefined,
                        false,
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
